import React from 'react'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { StudentTopMenuLayout } from '../../Layout/StudentTopMenu/StudentTopMenuLayout'
import { BookList } from './BookList'
import { useParams } from 'react-router-dom'

const StudentBookList = () => {
	const { user } = useAuth()
	const { studentId } = useParams()
	const isInstructorView = user?.role === 'Instructor'
	const effectiveStudentId = isInstructorView ? studentId : user?.id

	if (!effectiveStudentId) {
		return (
			<div className="text-center p-5">
				<div className="spinner-border text-primary" role="status">
					<span className="visually-hidden">Loading...</span>
				</div>
			</div>
		)
	}

	return (
		<StudentTopMenuLayout activeMenu="BookList" pageName="Book List">
			<BookList slug={effectiveStudentId} />
		</StudentTopMenuLayout>
	)
}

export { StudentBookList }
